import React, { Fragment, useState } from 'react';
import { useLocation } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
import {Spinner} from "react-bootstrap";

function Widget({ number, title }) {
	return (
		<div className="media-body">
			<h2 className="fs-38 text-black font-w600">{number}</h2>
			<span className="fs-18">{title}</span>
		</div>
	)
}
const Home = () => {
	const { getRequest } = useRequests();
	const [loading, setLoading] = useState(true);

	const location = useLocation();
	const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, process.env.REACT_APP_ALERT_AUTO_CLOSE);
	};

	const [events, setEvents] = useState(0);
	const fetchEvents = async () => {
		const response = await getRequest("event-list"); // Replace "users" with the appropriate API endpoint
		// const response = resultData[0]
		if (response && response.code === 200) {
		  setEvents(response.data.length);
		  fetchUsers();
		} else {
		  console.error("Failed to fetch events:", response.message);
		  setAlertData((AlertData) => ({
			...AlertData,
			variant: 'error',
			message: 'Failed to fetch events',
		  }));
		}
		resetAlertData();
	  };

  	  const [users, setUsers] = useState(0);
	  const fetchUsers = async () => {
		const response = await getRequest("user-list"); // Replace "users" with the appropriate API endpoint
		if (response && response.code === 200) {
		  setUsers(response.data.length);
		  fetchOrganizers();
		} else {
		  console.error("Failed to fetch users:", response.message);
		  setAlertData((AlertData) => ({
			...AlertData,
			variant: 'error',
			message: 'Failed to fetch users',
		  }));
		}
		resetAlertData();
	  };

	  const [organizers, setOrganizers] = useState(0);
	  const fetchOrganizers = async () => {
		const response = await getRequest("o-list"); // Replace "users" with the appropriate API endpoint
		if (response && response.code === 200) {
		  setOrganizers(response.data.length);
		  fetchResaleTickets();
		} else {
		  console.error("Failed to fetch organizers:", response.message);
		  setAlertData((AlertData) => ({
			...AlertData,
			variant: 'error',
			message: 'Failed to fetch organizers',
		  }));
		}
		resetAlertData();
	  };

	  const [totalTicketsPrice, settotalTicketsPrice] = useState(0);
	  const [todayTotalTicketsPrice, setTodayTotalTicketsPrice] = useState(0);
	  const [totalRevenue, setTotalRevenue] = useState(0);
	  const [todayTotalRevenue, setTodayTotalRevenue] = useState(0);

	  const fetchResaleTickets = async () => {
		const response = await getRequest(`purchase-tickets`); // Replace "users" with the appropriate API endpoint
		if (response && response.code === 200) {
			let totalPrice= 0;
			let todayTotalPrice= 0;
			let totalRevenue= 0;
			let todayTotalRevenue= 0;

			response.data.forEach(async element => {
				totalPrice= Number(totalPrice) + Number(element.purchase_price);
				totalRevenue= Number(totalRevenue) + Number(element.adminfees) + Number(element.platform_fee);

				const today = new Date();
				today.setHours(0, 0, 0, 0);

				const purchase_date = new Date(element.purchase_date);
				purchase_date.setHours(0, 0, 0, 0);

				if(purchase_date.getTime() == today.getTime()){
					todayTotalPrice= Number(todayTotalPrice) + Number(element.purchase_price);
					todayTotalRevenue= Number(todayTotalRevenue) + Number(element.adminfees) + Number(element.platform_fee);
				}

			});
			settotalTicketsPrice(totalPrice);
			setTodayTotalTicketsPrice(todayTotalPrice);
			setTotalRevenue(totalRevenue);
			setTodayTotalRevenue(todayTotalRevenue);
		} else {
		  console.error("Failed to fetch users tickets:", response.message);
		  setAlertData((AlertData) => ({
			...AlertData,
			variant: 'error',
			message: response.message,
		  }));
		}
		resetAlertData();
		setLoading(false);
	  };
	

	React.useEffect(() => {
		fetchEvents();
		if (location.state && typeof location.state.message !== 'undefined') {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: location.state.status,
				message: location.state.message,
			}));
			resetAlertData();
		}
	}, []);

	return (
		<Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
			
			{loading ? (
              <div className='text-center'>
                <Spinner animation='border'variant="primary"  />
                <p>Loading Dashboard...</p>
              </div>
            ) : (
			<div className="row">
			<div className="form-head mb-4">
			<h2 className="text-black font-w600 mb-0">Dashboard</h2>
			</div>
				<div className="col-xl-4 col-sm-6">
					<div className="card">
						<div className="card-body">
							<div className="media align-items-center">
								<Widget number={`${events}`}  title="Total Events" />
								<span className="p-3 border ms-3 rounded-circle">
								<i class="far fa-calendar-alt"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-4 col-sm-6">
					<div className="card">
						<div className="card-body">
							<div className="media align-items-center">
								<Widget number={`${users}`} title="Total Users" />
								<span className="p-3 border ms-3 rounded-circle">
								<i class="fas fa-user"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-4 col-sm-6">
					<div className="card">
						<div className="card-body">
							<div className="media align-items-center">
								<Widget number={`${organizers}`} title="Total Organizers" />
								<span className="p-3 border ms-3 rounded-circle">
								<i class="fas fa-user-tie"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-4 col-sm-6">
					<div className="card">
						<div className="card-body">
							<div className="media align-items-center">
								<Widget number={"Rs "+totalTicketsPrice} title="Total Ticket Sales" />
								<span className="p-3 border ms-3 rounded-circle">
								<i class="far fa-money-bill-alt"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-4 col-sm-6">
					<div className="card">
						<div className="card-body">
							<div className="media align-items-center">
								<Widget number={"Rs "+ todayTotalTicketsPrice} title="Total Ticket Sales for Today" />
								<span className="p-3 border ms-3 rounded-circle">
								<i class="far fa-money-bill-alt"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-4 col-sm-6">
					<div className="card">
						<div className="card-body">
							<div className="media align-items-center">
								<Widget number={"Rs "+ totalRevenue} title="Total Revenue" />
								<span className="p-3 border ms-3 rounded-circle">
								<i class="far fa-money-bill-alt"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-4 col-sm-6">
					<div className="card">
						<div className="card-body">
							<div className="media align-items-center">
								<Widget number={"Rs "+ todayTotalRevenue} title="Total Revenue for Today" />
								<span className="p-3 border ms-3 rounded-circle">
								<i class="far fa-money-bill-alt"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
				{/* <div className="col-xl-12">
					<div className="row">
						<div className="col-xl-12">
							<div className="card">
								<div className="card-header d-sm-flex d-block border-0 pb-0">
									<div className="pr-3 me-auto mb-sm-0 mb-3">
										<h4 className="fs-20 text-black mb-1">Last Year ( 2024 ) Transaction Overview</h4>
										<span className="fs-12">Lorem ipsum dolor sit amet, consectetur</span>
									</div>
								</div>
								<div className="card-body pt-0">
									<div id="chartBar">
										<GradientArea />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div> */}
			</div>
            )}

		</Fragment>
	)
}
export default Home;
